module.exports = __webpack_public_path__ + "static/fonts/iconfont.520b964.woff";


//////////////////
// WEBPACK FOOTER
// ./static/font-icons/iconfont.woff?t=1494485609225
// module id = 1022
// module chunks = 1